var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.4877 10.7578L7.0002 5.24531L12.5127 10.7578","stroke":"#CECABD","strokeWidth":"1.4"}));
}

ChevronUp.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
